<template>
  <div class="member">
    <img class="img" src="https://ysh-cdn.kaidicloud.com/app/h5/bg1.png" />
    <img class="img" src="https://ysh-cdn.kaidicloud.com/app/h5/bg2.png" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.member {
  min-height: 100vh;
  background: #0c0b09;
}
.img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}
</style>
